<template>
  <v-select class="service-code"
            v-model="selectedCodeGroup"
            :options="codeGroups"
            style="width: 180px;"
            :disabled="!(serviceTypeId)"
            @update:modelValue="onGroupCodechange"
            >
  </v-select>
  <v-select class="service-code"
            v-model="selectedValue"
            :options="serviceCodeOptions"
            label="display_name"
            style="width: 200px;"
            :disabled="!(selectedCodeGroup)"
            @update:modelValue="onChange"
            >
  </v-select>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import _ from 'underscore'

const props = defineProps({
  modelValue: {
    type: [String, Number, null],
    default: null
  },
  serviceTypeId: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const store = useStore()
const serviceCodes = ref([])
const selectedValue = ref('')
const codeGroups = ref([])
const selectedCodeGroup = ref('')
const serviceCodeOptions = ref([])

// Computed
const getServiceUniqueCodes = computed(() => store.getters['session/getTeresaStandardServiceUniqueCodes'])

// Methods
const onChange = (event) => {
  emit('update:modelValue', selectedValue.value ? selectedValue.value.id : null)
  emit('change', event)
}

const initServiceCode = () => {
  if (props.serviceTypeId) {
    serviceCodes.value = getServiceUniqueCodes.value(props.serviceTypeId)
  } else {
    serviceCodes.value = []
  }
  codeGroups.value = _.uniq(serviceCodes.value.map(serviceCode => serviceCode?.code_group))

  selectedValue.value = _.find(serviceCodes.value, (serviceCode) => {
    return (serviceCode.id === Number(props.modelValue))
  })
  selectedCodeGroup.value = selectedValue.value?.code_group
}

const onGroupCodechange = () => {
  selectedValue.value = null
}

// Watchers
watch(() => props.modelValue, (newVal) => {
  selectedValue.value = _.find(serviceCodes.value, (serviceCode) => {
    return (serviceCode.id === Number(newVal))
  })

  if (newVal) {
    selectedCodeGroup.value = selectedValue.value?.code_group
  }
})

watch(() => props.serviceTypeId, () => {
  initServiceCode()
})

watch(() => selectedValue.value, (newVal) => {
  emit('update:modelValue', newVal ? newVal.id : null)
})

watch(() => selectedCodeGroup.value, (newVal) => {
  if (newVal) {
    serviceCodeOptions.value = serviceCodes.value.filter(serviceCode => serviceCode?.code_group === newVal)
  }
})

// Lifecycle hooks
onMounted(() => {
  initServiceCode()
})
</script>

<style scoped>

</style>
